<div class="version-item" >
  <div [ngClass]="{'primary-background':active}">
    <div class="version-item-header">{{version.created_at|localizeDate:'medium'}} <span *ngIf="version.user?.last_name">by <span class="version-user">{{version.user.first_name}} {{version.user.last_name}}</span></span></div>
    <div class="version-name">{{version.name}}</div>    
    <div class="version-description" [innerHTML]="version.description | safeHtml"></div>
    <div class="version-menu">
      <p-button severity="info" variant="text" (click)="getVersion(version)"><i class="far fa-eye"></i> {{'view'| translation}}</p-button><p-button severity="info" variant="text" *ngIf="version.id" (click)="createFrom()"><i class="far fa-copy"></i>{{'course_copy_to_new'| translation}}</p-button>
    </div>
  </div>
</div>
